import axios from "utils/axios";

export const getFinanceTransactionsJournal = (id) => {
  return axios.get(`/finance/transactions/${id}/journals`);
};
